import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const SEPA = ({ bankAccount, mandateButton, companyName, taxId, address }) => {
  const theme = useTheme()
  const { info } = useContext(AppContext)
  const { t } = useTranslation()

  return (
    <>
      <Styles.Container>
        <Styles.SEPAContainer>
          <Styles.InfoContainer>
            <Styles.InfoTitle>{t('Acreedor')}</Styles.InfoTitle>
            <Styles.InfoContent>
              <div>
                <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                  {t('Nombre empresa')}
                </Text>
                <Text type="bodyMRegular">{companyName}</Text>
              </div>
              <div>
                <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                  {t('ID del acreedor')}:
                </Text>
                <Text type="bodyMRegular">{taxId}</Text>
              </div>
              <div>
                <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                  {t('Dirección')}
                </Text>
                <div>
                  <Text type="bodyMRegular">
                    {address?.line_1} {address?.line_2}
                  </Text>
                  <Text type="bodyMRegular">
                    {address?.postcode} {address?.province.name} {address?.locality}
                  </Text>
                  <Text type="bodyMRegular">{address?.country?.name}</Text>
                </div>
              </div>
            </Styles.InfoContent>
          </Styles.InfoContainer>
          <Styles.InfoContainer>
            <Styles.InfoTitle>{t('Deudor')}</Styles.InfoTitle>
            <Styles.InfoContent>
              <div>
                <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                  {t('Nombre empresa')}
                </Text>
                <Text type="bodyMRegular">
                  {info?.billing_data?.business_name_1} {info?.billing_data?.business_name_2}
                </Text>
              </div>
              <div>
                <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                  SEPA Direct Debit:
                </Text>
                {bankAccount?.number && bankAccount?.is_request_fulfilled ? (
                  <Text type="bodyMRegular">
                    {t('Firmado ({{bankNumber}})', {
                      bankNumber: bankAccount?.number,
                    })}
                  </Text>
                ) : (
                  <Styles.PendingSignContainer>
                    <Alert type="error" size="s">
                      {t('PENDIENTE')}
                    </Alert>
                  </Styles.PendingSignContainer>
                )}
              </div>
              <div>
                <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                  {t('Dirección')}
                </Text>
                <div>
                  <Text type="bodyMRegular">{info?.billing_data?.business_address?.line_1}</Text>
                  <Text type="bodyMRegular">
                    {info?.billing_data?.business_address?.line_2} {info?.billing_data?.business_address?.postcode}{' '}
                    {info?.billing_data?.business_address?.locality}{' '}
                    {info?.billing_data?.business_address?.province?.name}
                  </Text>
                  <Text type="bodyMRegular">{info?.billing_data?.business_address?.country?.name}</Text>
                </div>
              </div>
              {mandateButton}
            </Styles.InfoContent>
          </Styles.InfoContainer>
        </Styles.SEPAContainer>
      </Styles.Container>
    </>
  )
}

export default SEPA
